<template>
  <div v-if="!itemsCount" class="search-not-found">
    <div class="search-not-container">
      <div class="search-not-block">
        <div class="search-not-content">
          <DefTitle result="1">
            <h1>
              {{ messages.nothingFound }}
              <span class="search-not-beige">{{ getRequestText }}</span>
            </h1>
          </DefTitle>
          <p class="search-not-text">
            {{ messages.tryAgain }}
            <DefLink v-if="messages.onMainPage" :href="messages.onMainPage.name">
              {{ messages.onMainPage.name }}
            </DefLink>
          </p>

          <Engine :params="result" />
        </div>
        <DefImg
          v-if="screenWidth >= 992"
          :result="{ src: '/local/templates/sova/images/front-end/search/not-found.png' }"
        />
      </div>
    </div>
    <DefImg
      v-if="screenWidth < 992"
      :result="{ src: '/local/templates/sova/images/front-end/search/not-found.png' }"
    />
  </div>
  <div v-if="!itemsCount" class="container">
    <ProductSliderRevised />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import useScreenWidth from '@use/useScreenWidth';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefLink from '@components/Def/DefLink/DefLink.vue';
import Engine from '@components/Search/Engine.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import ProductSliderRevised from "@components/Product/sliders/ProductSliderRevised.vue";

export default {
  name: 'CatalogNotFound',
  components: { ProductSliderRevised, DefImg, Engine, DefLink, DefTitle },
  props: ['result'],
  data() {
    return {
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    ...mapState({
      messages: ({ results }) => results?.messages,
      itemsCount: ({ catalog }) => catalog?.data?.catalogSectionList?.count,
    }),
    getRequestText() {
      const searchParams = new URLSearchParams(location.search);

      // Итерируем параметры поиска.
      for (const p of searchParams) {
        if (p[0] === 'q') {
          return p[1];
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-not-found {
  background-color: #f6f6f6;
  margin-bottom: 64px;
  :deep(.def-input) {
    height: auto;
  }
  :deep(.def-input__input) {
    background-color: transparent;
  }
}
.search-not-container {
  @extend %container;
}
.search-not-block {
  display: grid;
  grid-template-columns: 1fr;
  @include point-lg {
    grid-template-columns: 1fr 1fr;
    justify-content: space-between;
  }
}
.search-not-beige {
  background-color: #efe6cc;
  padding: 0 2px;
}
.search-not-text {
  margin-bottom: 32px;
  @include point-md {
    margin-bottom: 58px;
  }
  @include point-lg {
    margin-bottom: 38px;
  }
}
.search-not-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px 0 40px;
  @include point-md {
    padding: 40px 0 48px;
  }
  @include point-lg {
    max-width: 460px;
  }
}
</style>
